(() => {
  injectCROPatch();
  document.querySelectorAll('product-info.it-jewellery-pdp:not([data-it-ready])').forEach(init);
  function init(root){
    root.dataset.itReady='true';
    const sectionId=root.dataset.section;
    const handle=root.dataset.productHandle||'';
    const threshold=Number(root.dataset.offerThreshold||100000);
    const node=root.querySelector('[data-it-variant-data]');
    let variants=[];try{variants=JSON.parse(node?.textContent||'[]')}catch(e){}
    const hidden=root.querySelector(`#product-form-${esc(sectionId)} input[name="id"]`);
    const submit=root.querySelector(`#ProductSubmitButton-${esc(sectionId)}`);
    const sticky=root.querySelector('[data-it-mobile-purchase]');
    const stickyBtn=root.querySelector('[data-it-mobile-add]');
    const stickyPrice=root.querySelector('[data-it-mobile-price]');
    const offerBtn=root.querySelector('[data-it-offer-open]');
    const dialog=root.querySelector('[data-it-offer-dialog]');
    const wa=root.querySelector('[data-it-whatsapp]');
    decorate();decorateConversionIcons();sync();
    root.addEventListener('change',()=>setTimeout(()=>{decorate();sync()},40),true);
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.variantChange){subscribe(PUB_SUB_EVENTS.variantChange,e=>{if(e?.data?.sectionId===sectionId){decorate();sync(e.data.variant)}})}
    if(stickyBtn&&submit){stickyBtn.addEventListener('click',()=>{if(document.body.classList.contains('overflow-hidden')||document.body.classList.contains('imperial-commerce-overlay-open')||document.body.classList.contains('it-offer-open'))return;const f=root.querySelector(`#product-form-${esc(sectionId)}`);if(f?.requestSubmit)f.requestSubmit(submit);else submit.click()});if('IntersectionObserver'in window){new IntersectionObserver(es=>{const v=es[0]?.isIntersecting;sticky?.classList.toggle('is-visible',!v&&!submit.disabled);sticky?.setAttribute('aria-hidden',v||submit.disabled?'true':'false');if(!v&&!submit.disabled)requestAnimationFrame(updateChatClearance)},{threshold:.12}).observe(submit)}}
    if(sticky){let chatTick=false;const scheduleChatClearance=()=>{if(chatTick)return;chatTick=true;requestAnimationFrame(()=>{chatTick=false;updateChatClearance()})};const bindChatHost=chat=>{if(!chat||chat.dataset.itClearanceBound==='1')return;chat.dataset.itClearanceBound='1';chat.addEventListener('click',()=>setTimeout(scheduleChatClearance,60));new MutationObserver(scheduleChatClearance).observe(chat,{attributes:true,attributeFilter:['class','style','hidden']})};updateChatClearance();addEventListener('resize',scheduleChatClearance,{passive:true});[250,1000,2500].forEach(ms=>setTimeout(scheduleChatClearance,ms));const existingChat=document.querySelector('shopify-chat');if(existingChat){bindChatHost(existingChat)}else{const finder=new MutationObserver(()=>{const chat=document.querySelector('shopify-chat');if(chat){bindChatHost(chat);finder.disconnect();scheduleChatClearance()}});finder.observe(document.body,{childList:true,subtree:true});setTimeout(()=>finder.disconnect(),4000)}}
    if(offerBtn&&dialog){const syncOfferState=()=>document.body.classList.toggle('it-offer-open',Boolean(dialog.open));offerBtn.addEventListener('click',()=>{if(typeof dialog.showModal==='function'){dialog.showModal();syncOfferState()}});dialog.querySelector('[data-it-offer-close]')?.addEventListener('click',()=>dialog.close());dialog.addEventListener('close',syncOfferState);dialog.addEventListener('cancel',()=>requestAnimationFrame(syncOfferState));dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()})}
    parallax();
    function current(){return variants.find(v=>String(v.id)===String(hidden?.value||''))}
    function sync(v=current()){if(!v)return;if(stickyPrice)stickyPrice.textContent=money(v.price);if(stickyBtn){stickyBtn.disabled=!v.available;stickyBtn.textContent=v.available?'Add to Bag':'Sold out'}if(offerBtn)offerBtn.hidden=Number(v.price)<threshold;if(wa){const title=root.querySelector('h1')?.textContent?.trim()||'this item';wa.href=`https://wa.me/447538174795?text=${encodeURIComponent(`Hello Imperial Time UK Ltd, I am interested in ${title} - ${location.href}`)}`}}
    function decorate(){root.querySelectorAll('[data-it-variant-zone] variant-selects fieldset').forEach((fs,index)=>{const legend=fs.querySelector('legend');if(!legend)return;const raw=(legend.textContent.split(':')[0]||'').trim();let display=raw;if(handle==='925-silver-rhodium-single-clover-pendant-black-onyx-colour'&&raw.toLowerCase()==='weight')display='Stone / colour';if(legend.childNodes[0])legend.childNodes[0].textContent=`${display}: `;const n=display.toLowerCase();if(/size/.test(n))fs.classList.add('it-size-options');const imageLed=/colour|color|stone|metal|material/.test(n)||(handle==='925-silver-rhodium-single-clover-pendant-black-onyx-colour'&&index===0);if(!imageLed)return;const radios=[...fs.querySelectorAll('input[type=radio]')];if(!radios.length||radios.length>12)return;const hasImages=radios.some(i=>variants.some(v=>v.options?.[index]===i.value&&v.image));if(!hasImages)return;fs.classList.add('it-image-options');radios.forEach(input=>{const label=fs.querySelector(`label[for="${esc(input.id)}"]`);const variant=variants.find(v=>v.options?.[index]===input.value&&v.image);if(!label||!variant||label.querySelector('.it-option-thumb'))return;const text=input.value;label.textContent='';const img=document.createElement('img');img.className='it-option-thumb';img.src=variant.image;img.alt='';img.loading='lazy';const span=document.createElement('span');span.className='it-option-copy';span.textContent=text;label.append(img,span)})})}
    function decorateConversionIcons(){
      const waBtn=root.querySelector('.it-assist-button--whatsapp');
      if(waBtn&&!waBtn.querySelector('.it-assist-button__icon')){
        const icon=document.createElement('span');icon.className='it-assist-button__icon';icon.setAttribute('aria-hidden','true');icon.innerHTML='<svg viewBox="0 0 32 32" focusable="false" aria-hidden="true"><path fill="currentColor" d="M19.11 17.23c-.29-.15-1.7-.84-1.96-.93-.26-.1-.45-.15-.64.15-.19.29-.74.93-.91 1.12-.17.19-.33.22-.62.08-.29-.15-1.21-.45-2.3-1.44-.85-.76-1.42-1.69-1.58-1.98-.17-.29-.02-.44.12-.59.13-.13.29-.33.43-.5.15-.17.19-.29.29-.48.1-.19.05-.36-.02-.5-.08-.15-.64-1.54-.88-2.11-.23-.55-.46-.48-.64-.49h-.55c-.19 0-.5.07-.76.36-.26.29-1 1-.99 2.43 0 1.43 1.03 2.81 1.17 3 .15.19 2.04 3.11 5.03 4.37.71.31 1.27.5 1.7.64.71.23 1.35.2 1.86.12.57-.09 1.7-.69 1.94-1.36.24-.67.24-1.24.17-1.36-.07-.12-.26-.19-.55-.34z"/><path fill="currentColor" d="M16.02 3.2c-7.05 0-12.77 5.71-12.78 12.75 0 2.25.59 4.46 1.71 6.41L3.2 28.8l6.58-1.72a12.8 12.8 0 0 0 6.24 1.59h.01c7.04 0 12.77-5.71 12.78-12.76A12.73 12.73 0 0 0 16.02 3.2zm0 23.31h-.01a10.64 10.64 0 0 1-5.42-1.49l-.39-.23-3.9 1.02 1.04-3.8-.25-.39a10.57 10.57 0 0 1-1.63-5.63c0-5.87 4.78-10.64 10.66-10.64 2.84 0 5.51 1.1 7.52 3.12a10.55 10.55 0 0 1 3.11 7.52c0 5.87-4.79 10.64-10.67 10.64z"/></svg>';
        waBtn.prepend(icon);
      }
      const cards=[...root.querySelectorAll('.it-jewellery-why__grid article')];
      const paths=['M12 2l7 3v5c0 5.25-3.44 9.84-7 11-3.56-1.16-7-5.75-7-11V5l7-3zm0 4.1L7 8v2c0 4.05 2.52 7.63 5 8.68 2.48-1.05 5-4.63 5-8.68V8l-5-1.9zm-1.1 7.82-1.92-1.91-1.41 1.41 3.33 3.33 5.66-5.66-1.41-1.41-4.25 4.24z','M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm1 2v10h14V7H5zm3 8 2.5-3 2 2.5 3-4L18 15H8zm1.5-5.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z','M3 7.5 12 3l9 4.5v9L12 21l-9-4.5v-9zm9-2.28L6.44 8 12 10.78 17.56 8 12 5.22zM5 9.24v6.02l6 3v-6.02l-6-3zm8 9.02 6-3V9.24l-6 3v6.02z','M12 3a8 8 0 0 0-8 8v3.5A2.5 2.5 0 0 0 6.5 17H8v-6H6a6 6 0 0 1 12 0h-2v6h1.5a2.5 2.5 0 0 0 2.5-2.5V11a8 8 0 0 0-8-8zm-2 9h4v5h-4v-5zm-1 7h6v2H9v-2z'];
      cards.forEach((card,i)=>{if(card.querySelector('.it-why-icon')||!paths[i])return;const icon=document.createElement('div');icon.className='it-why-icon';icon.setAttribute('aria-hidden','true');icon.innerHTML=`<svg viewBox="0 0 24 24" focusable="false"><path fill="currentColor" d="${paths[i]}"/></svg>`;const num=card.querySelector(':scope > span');num?.after(icon);});
    }
    function updateChatClearance(){if(!sticky||innerWidth>749)return;let clearance=12;let sideClear=false;const candidates=[...document.querySelectorAll('iframe,[class*=chat],[id*=chat],[class*=inbox],[id*=inbox],[aria-label*=message i],[aria-label*=chat i]')];for(const el of candidates){if(el.closest('product-info.it-jewellery-pdp'))continue;const r=el.getBoundingClientRect();if(r.width<28||r.height<28||r.width>220||r.height>220)continue;if(r.right<innerWidth-170||r.bottom<innerHeight-170)continue;const cs=getComputedStyle(el);if(cs.display==='none'||cs.visibility==='hidden'||Number(cs.opacity)===0)continue;const visible=r.bottom>0&&r.right>0&&r.left<innerWidth&&r.top<innerHeight;if(!visible)continue;clearance=Math.max(clearance,Math.min(118,innerHeight-r.top+10));sideClear=true;}sticky.style.setProperty('--it-chat-clearance',`${clearance}px`);sticky.classList.toggle('is-chat-clear',sideClear&&clearance<70)}
    function parallax(){if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;const media=root.querySelector('[data-it-parallax]');if(!media)return;let active=false,tick=false;new IntersectionObserver(es=>active=!!es[0]?.isIntersecting).observe(media.parentElement);addEventListener('scroll',()=>{if(active&&!tick){tick=true;requestAnimationFrame(()=>{tick=false;const r=media.parentElement.getBoundingClientRect();const p=(innerHeight-r.top)/(innerHeight+r.height);media.style.transform=`translate3d(0,${Math.max(-26,Math.min(26,(p-.5)*52))}px,0)`})}},{passive:true})}
    function money(p){return new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',minimumFractionDigits:0,maximumFractionDigits:2}).format(Number(p)/100)}
  }
  function injectCROPatch(){
    if(document.getElementById('it-jewellery-cro-patch-20260903'))return;
    const style=document.createElement('style');style.id='it-jewellery-cro-patch-20260903';style.textContent=`
.it-jewellery-pdp{--it-green:#25D366;--it-green-hover:#1ebe5b}.it-assist-button--whatsapp{background:var(--it-green)!important;border-color:var(--it-green)!important;color:#fff!important;gap:8px}.it-assist-button--whatsapp:hover{background:var(--it-green-hover)!important;border-color:var(--it-green-hover)!important;color:#fff!important;filter:none}.it-assist-button__icon{display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;flex:0 0 18px}.it-assist-button__icon svg{display:block;width:100%;height:100%}.it-jewellery-why__grid article{position:relative}.it-why-icon{display:flex;align-items:center;justify-content:center;width:48px;height:48px;margin:18px 0 14px;border-radius:50%;background:#f4efe5;color:var(--it-navy)}.it-why-icon svg{display:block;width:24px;height:24px}.it-jewellery-why__grid h3{margin:0 0 9px}
@media(min-width:991px){.it-jewellery-shell{padding-top:24px;padding-bottom:48px}.it-jewellery-hero{grid-template-columns:minmax(0,1.34fr) minmax(420px,.84fr);gap:clamp(48px,5vw,86px);align-items:start}.it-jewellery-buybox{display:flex;justify-content:flex-end}.it-jewellery-buybox__inner{width:min(100%,500px);padding-top:6px}.it-jewellery-buybox__inner--sticky{top:96px}.it-jewellery-title{max-width:18ch;margin:12px 0 14px;font-size:clamp(31px,2.2vw,43px);line-height:1.06}.it-jewellery-price-row{padding-bottom:13px}.it-jewellery-payment-note{margin:8px 0 14px}.it-jewellery-variants .product-form__input{margin-bottom:11px}.it-jewellery-quantity{margin:1px 0 10px}.it-jewellery-assistance{margin-top:8px}.it-jewellery-assurances{margin-top:13px}.it-jewellery-helpnote{margin-top:8px}}
@media(max-width:990px){.it-why-icon{width:46px;height:46px;margin:16px 0 12px}.it-why-icon svg{width:23px;height:23px}}
@media(max-width:749px){.it-jewellery-why__grid{grid-template-columns:1fr}.it-jewellery-why__grid article{min-height:auto;padding:20px 18px}.it-why-icon{width:44px;height:44px;margin:14px 0 11px}.it-why-icon svg{width:22px;height:22px}.it-jewellery-why__grid h3{margin:0 0 8px}.it-mobile-purchase{--it-chat-clearance:12px;left:10px;right:10px;bottom:calc(var(--it-chat-clearance) + env(safe-area-inset-bottom));z-index:34;grid-template-columns:auto minmax(0,1fr);max-width:500px;padding:7px 8px;border:1px solid #d8d5cf;background:rgba(255,255,255,.98);box-shadow:0 10px 30px rgba(0,0,0,.14);transition:transform .22s ease,visibility .22s ease,opacity .22s ease,bottom .18s ease}.it-mobile-purchase__price{min-width:70px;padding-left:2px;font-size:12px}.it-mobile-purchase__button{min-height:43px;font-size:12.5px}.it-mobile-purchase.is-chat-clear{right:82px;max-width:calc(100vw - 92px)}}
@media(max-width:390px){.it-mobile-purchase{left:8px;right:8px}.it-mobile-purchase.is-chat-clear{right:76px;max-width:calc(100vw - 84px)}.it-mobile-purchase__price{min-width:64px;font-size:11.5px}}`;
    document.head.appendChild(style);
  }
  function esc(v){return window.CSS?.escape?CSS.escape(String(v)):String(v).replace(/[^a-zA-Z0-9_-]/g,'\\$&')}
})();
;
(() => {
  const SCRIPT_VERSION = '2026-09-16-final-pass-v1';
  function boot() {
    applyAll();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(applyAll));
  document.addEventListener('change', event => {
    if (event.target?.closest?.('product-info.it-jewellery-pdp')) {
      requestAnimationFrame(applyAll);
    }
  }, true);
  function applyAll() {
    document.querySelectorAll('product-info.it-jewellery-pdp').forEach(applyProduct);
  }
  function applyProduct(root) {
    const sectionId = root.dataset.section || '';
    const context = readContext(sectionId, root);
    const family = detectFamily(context.productType, context.title);
    root.dataset.itJewelleryFamily = family;
    root.dataset.itFinalPass = SCRIPT_VERSION;
    removeDuplicateSupport();
    polishVariantPickers(root, family, context);
    sanitizeProductOverview(root, family, context);
    sanitizeSpecs(root, family);
    rewriteAssuranceContent(root, family);
    polishConfidenceSuite(family);
  }
  function readContext(sectionId, root) {
    const node = document.getElementById(`ItJewelleryFinalContext-${sectionId}`);
    let data = {};
    try { data = JSON.parse(node?.textContent || '{}'); } catch (_) {}
    return {
      productType: String(data.productType || ''),
      title: String(data.title || root.querySelector('h1')?.textContent || ''),
      metal: String(data.metal || ''),
      purity: String(data.purity || ''),
      mainStone: String(data.mainStone || '')
    };
  }
  function detectFamily(productType, title) {
    const type = productType.toLowerCase();
    const text = `${productType} ${title}`.toLowerCase();
    if (/earring/.test(type)) return 'earring';
    if (/bracelet|bangle/.test(type)) return 'bracelet';
    if (/ring|wedding band/.test(type)) return 'ring';
    if (/pendant|charm/.test(type)) return 'pendant';
    if (/chain|necklace/.test(type)) return 'chain';
    if (/earring/.test(text)) return 'earring';
    if (/bracelet|bangle/.test(text)) return 'bracelet';
    if (/ring|wedding band/.test(text)) return 'ring';
    if (/pendant|cross|charm/.test(text)) return 'pendant';
    if (/chain|necklace/.test(text)) return 'chain';
    return 'jewellery';
  }
  function removeDuplicateSupport() {
    document.querySelectorAll('[data-it-et-support-v01], .it-et-support-v01').forEach(node => {
      if (node.tagName === 'STYLE') return;
      node.remove();
    });
  }
  function polishVariantPickers(root, family, context) {
    const fieldsets = [...root.querySelectorAll('[data-it-variant-zone] variant-selects fieldset')];
    fieldsets.forEach((fieldset, index) => {
      const legend = fieldset.querySelector('legend');
      if (!legend) return;
      const radios = [...fieldset.querySelectorAll('input[type="radio"]')];
      const values = radios.map(input => String(input.value || '').trim()).filter(Boolean);
      const raw = String((legend.textContent || '').split(':')[0] || '').trim();
      const rawLower = raw.toLowerCase();
      if (isSyntheticOption(rawLower, values)) {
        fieldset.hidden = true;
        fieldset.classList.add('it-final-synthetic-option');
        fieldset.setAttribute('aria-hidden', 'true');
        return;
      }
      if (family === 'chain' && isChainMatrix(values)) {
        installChainPicker(root, fieldset, values, context);
        return;
      }
      const displayName = optionDisplayName(raw, family, context.title);
      setLegendText(legend, displayName);
      if (/metal|material/i.test(raw) || /metal/i.test(displayName)) {
        fieldset.classList.add('it-metal-options', 'it-final-metal-options');
        radios.forEach(input => decorateMetalLabel(fieldset, input, context.title));
      }
      if (/size/i.test(displayName)) fieldset.classList.add('it-size-options', 'it-final-size-options');
      if (/length/i.test(displayName)) fieldset.classList.add('it-final-length-options');
      if (/stone|gem|colour|color/i.test(displayName)) fieldset.classList.add('it-final-stone-options');
      fieldset.dataset.itFinalOptionIndex = String(index);
    });
  }
  function isSyntheticOption(name, values) {
    if (values.length !== 1) return false;
    const value = values[0].toLowerCase();
    if (name === 'default' && value === 'default') return true;
    if (name === 'title' && value === 'default title') return true;
    return false;
  }
  function optionDisplayName(raw, family, title) {
    const n = raw.toLowerCase().trim();
    if (n === 'color') return 'Colour';
    if (family === 'ring' && (n === 'size' || /ring\s*size/.test(n))) return 'Ring size';
    if (family === 'bracelet' && n === 'size') return 'Bracelet size';
    if (family === 'bracelet' && n === 'length') return 'Bracelet length';
    if (family === 'chain' && n === 'length') return 'Chain length';
    if (/metal|material/.test(n)) return 'Metal';
    if (/stone|gem/.test(n) && /colour|color|type/.test(n)) return 'Stone / colour';
    if (n === 'weight' && /stone|onyx|malachite|agate|pearl|diamond|ruby|sapphire|emerald|topaz|amethyst|opal|turquoise|garnet|quartz|zircon|moissanite/i.test(title)) return 'Stone / colour';
    return raw;
  }
  function setLegendText(legend, text) {
    if (!legend) return;
    const selected = legend.querySelector('[data-selected-value], .selected-value');
    [...legend.childNodes].forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) node.remove();
    });
    legend.insertBefore(document.createTextNode(text), legend.firstChild || null);
    if (selected) selected.remove();
  }
  function decorateMetalLabel(fieldset, input, title) {
    const label = fieldset.querySelector(`label[for="${cssEscape(input.id)}"]`);
    if (!label) return;
    const display = inferMetalDisplay(input.value, title);
    let tone = label.querySelector('.it-metal-tone');
    if (!tone) {
      tone = document.createElement('span');
      tone.className = 'it-metal-tone';
      tone.setAttribute('aria-hidden', 'true');
      label.prepend(tone);
    }
    tone.style.setProperty('--it-metal-tone', toneFor(display));
    let copy = label.querySelector('.it-final-metal-copy');
    if (!copy) {
      copy = document.createElement('span');
      copy.className = 'it-final-metal-copy';
      [...label.childNodes].forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) node.remove();
      });
      label.append(copy);
    }
    copy.textContent = display;
  }
  function inferMetalDisplay(value, title) {
    const raw = String(value || '').trim();
    if (!/gold/i.test(raw) || /yellow|white|rose/i.test(raw)) return raw;
    const titleLower = String(title || '').toLowerCase();
    if (titleLower.includes('rose gold')) return raw.replace(/gold/i, 'Rose Gold');
    if (titleLower.includes('white gold')) return raw.replace(/gold/i, 'White Gold');
    if (titleLower.includes('yellow gold')) return raw.replace(/gold/i, 'Yellow Gold');
    return raw;
  }
  function isChainMatrix(values) {
    if (values.length < 4) return false;
    const matches = values.filter(value => parseChainValue(value)).length;
    return matches / values.length >= 0.8;
  }
  function parseChainValue(value) {
    const text = String(value || '').trim();
    const match = text.match(/^\s*(\d+(?:\.\d+)?)\s*(?:"|in|inch|inches)\s*\/\s*(\d+(?:\.\d+)?)\s*mm\s*$/i);
    if (!match) return null;
    return {
      raw: text,
      length: `${match[1]}\"`,
      lengthNumber: Number(match[1]),
      gauge: `${match[2]}mm`,
      gaugeNumber: Number(match[2])
    };
  }
  function installChainPicker(root, fieldset) {
    fieldset.classList.add('it-final-chain-native');
    fieldset.hidden = true;
    fieldset.setAttribute('aria-hidden', 'true');
    const radios = [...fieldset.querySelectorAll('input[type="radio"]')];
    const parsed = radios.map(input => ({ input, ...parseChainValue(input.value) })).filter(item => item.raw);
    if (!parsed.length) return;
    let proxy = fieldset.previousElementSibling;
    if (!proxy?.matches?.('[data-it-chain-picker]')) {
      proxy = document.createElement('div');
      proxy.className = 'it-chain-picker';
      proxy.dataset.itChainPicker = 'true';
      fieldset.before(proxy);
    }
    const checked = parsed.find(item => item.input.checked) || parsed.find(item => !isRadioUnavailable(item.input)) || parsed[0];
    const gauges = [...new Map(parsed.slice().sort((a, b) => a.gaugeNumber - b.gaugeNumber).map(item => [item.gauge, item])).values()];
    const activeGauge = checked?.gauge || gauges[0]?.gauge;
    const lengths = parsed
      .filter(item => item.gauge === activeGauge)
      .sort((a, b) => a.lengthNumber - b.lengthNumber);
    proxy.innerHTML = '';
    const head = document.createElement('div');
    head.className = 'it-chain-picker__head';
    head.innerHTML = '<span>Choose length &amp; gauge</span><small>Pick a gauge, then choose an available length.</small>';
    const gaugeGroup = document.createElement('div');
    gaugeGroup.className = 'it-chain-picker__group';
    gaugeGroup.innerHTML = '<div class="it-chain-picker__label">Gauge</div>';
    const gaugeButtons = document.createElement('div');
    gaugeButtons.className = 'it-chain-picker__buttons it-chain-picker__buttons--gauge';
    gauges.forEach(gaugeEntry => {
      const availableForGauge = parsed.some(item => item.gauge === gaugeEntry.gauge && !isRadioUnavailable(item.input));
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'it-chain-choice';
      button.textContent = gaugeEntry.gauge;
      button.disabled = !availableForGauge;
      button.classList.toggle('is-selected', gaugeEntry.gauge === activeGauge);
      button.addEventListener('click', () => {
        const sameLength = parsed.find(item => item.gauge === gaugeEntry.gauge && item.length === checked?.length && !isRadioUnavailable(item.input));
        const target = sameLength || parsed.find(item => item.gauge === gaugeEntry.gauge && !isRadioUnavailable(item.input));
        if (target) target.input.click();
      });
      gaugeButtons.append(button);
    });
    gaugeGroup.append(gaugeButtons);
    const lengthGroup = document.createElement('div');
    lengthGroup.className = 'it-chain-picker__group it-chain-picker__group--length';
    lengthGroup.innerHTML = '<div class="it-chain-picker__label">Length</div>';
    const lengthButtons = document.createElement('div');
    lengthButtons.className = 'it-chain-picker__buttons it-chain-picker__buttons--length';
    lengths.forEach(item => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'it-chain-choice';
      button.textContent = item.length;
      button.disabled = isRadioUnavailable(item.input);
      button.classList.toggle('is-selected', item.input.checked);
      button.addEventListener('click', () => item.input.click());
      lengthButtons.append(button);
    });
    lengthGroup.append(lengthButtons);
    const selected = document.createElement('div');
    selected.className = 'it-chain-picker__selected';
    selected.innerHTML = `<span>Selected</span><strong>${escapeHtml(checked?.length || '')} · ${escapeHtml(checked?.gauge || '')}</strong>`;
    proxy.append(head, gaugeGroup, lengthGroup, selected);
  }
  function isRadioUnavailable(input) {
    return Boolean(input.disabled || input.classList.contains('disabled') || input.getAttribute('aria-disabled') === 'true');
  }
  function sanitizeProductOverview(root, family, context) {
    const details = root.querySelector('.it-jewellery-details');
    if (!details) return;
    let section = details.querySelector('.it-piece-summary');
    let paragraph = section?.querySelector('p:last-child');
    const currentText = String(paragraph?.textContent || '').replace(/\s+/g, ' ').trim();
    if (!section && !currentText) {
      section = document.createElement('section');
      section.className = 'it-piece-summary it-final-generated-summary';
      section.innerHTML = '<p class="it-section-kicker">ABOUT THIS PIECE</p><h2>Product overview</h2><p></p>';
      details.prepend(section);
      paragraph = section.querySelector('p:last-child');
    }
    if (!paragraph) return;
    if (!currentText || isBadOverview(currentText)) {
      paragraph.textContent = buildFallbackOverview(family, context);
      section.dataset.itFinalSummary = 'generated';
    }
  }
  function isBadOverview(text) {
    const pipes = (text.match(/\|/g) || []).length;
    const codeTokens = text.match(/\b[A-Z]{2,}\d[A-Z0-9-]*(?:-\d+(?:\.\d+)?)?\b/g) || [];
    const modelLed = /^\s*(?:model|sku|reference|ref\.?)[\s:]/i.test(text);
    const codeHeavy = codeTokens.length >= 4 && codeTokens.join(' ').length / Math.max(text.length, 1) > 0.22;
    return pipes >= 3 || (modelLed && codeTokens.length >= 2) || codeHeavy;
  }
  function buildFallbackOverview(family, context) {
    const material = materialPhrase(context);
    switch (family) {
      case 'chain':
        return `Crafted in ${material}, this chain is presented with a clean, versatile jewellery profile. Choose your preferred length and gauge from the available combinations above; the selected option determines the exact specification supplied.`;
      case 'pendant':
        return `Crafted in ${material}, this pendant is presented with a considered jewellery profile and an easy-to-wear finish. Key dimensions, stone details and other specifications are shown below where available.`;
      case 'ring':
        return `Crafted in ${material}, this ring balances proportion, finish and everyday wearability. Select the available size or metal option above where applicable; the exact specifications are shown below.`;
      case 'earring':
        return `Crafted in ${material}, these earrings are presented with a refined, wearable finish. Metal, stone and construction details are shown below where available, with specialist guidance available from our Kensington team.`;
      case 'bracelet':
        return `Crafted in ${material}, this bracelet is designed with a clean, wearable profile and attention to finish and proportion. Available size, length or metal options are shown above, with the exact specifications listed below.`;
      default:
        return `Crafted in ${material}, this piece is selected for its materials, finish and wearable design. The key specifications shown below reflect the product information available for this listing.`;
    }
  }
  function materialPhrase(context) {
    const metal = context.metal.trim();
    const purity = context.purity.trim();
    if (metal && purity && !metal.toLowerCase().includes(purity.toLowerCase())) return `${purity} ${metal.toLowerCase()}`;
    if (metal) return metal.toLowerCase();
    return 'the stated precious metal';
  }
  function sanitizeSpecs(root, family) {
    const table = root.querySelector('.it-cro-specs .it-spec-table');
    if (!table) return;
    const body = table.tBodies[0] || table;
    [...body.querySelectorAll('tr')].forEach(row => {
      const key = String(row.querySelector('th')?.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      const value = String(row.querySelector('td')?.textContent || '').replace(/\s+/g, ' ').trim();
      if ((/main stone|stone 1 type|stone type/.test(key) && /^no stone$/i.test(value)) ||
          (/approx\.? weight|average weight/.test(key) && ((value.match(/\|/g) || []).length >= 2 || (value.match(/\bg\b/gi) || []).length >= 4))) {
        row.remove();
        return;
      }
      if (family === 'chain' && /^(necklace length|length|gauge)$/.test(key)) row.remove();
    });
    body.querySelectorAll('tr[data-it-chain-spec]').forEach(row => row.remove());
    if (family !== 'chain') return;
    const selected = currentChainSelection(root);
    if (!selected) return;
    appendSpecRow(body, 'Length', selected.length, 'length');
    appendSpecRow(body, 'Gauge', selected.gauge, 'gauge');
  }
  function currentChainSelection(root) {
    const radios = [...root.querySelectorAll('[data-it-variant-zone] input[type="radio"]')];
    const input = radios.find(radio => radio.checked && parseChainValue(radio.value));
    return input ? parseChainValue(input.value) : null;
  }
  function appendSpecRow(body, key, value, id) {
    const row = document.createElement('tr');
    row.dataset.itChainSpec = id;
    const th = document.createElement('th');
    th.scope = 'row';
    th.textContent = key;
    const td = document.createElement('td');
    td.textContent = value;
    row.append(th, td);
    body.append(row);
  }
  function rewriteAssuranceContent(root) {
    const why = root.querySelector('.it-jewellery-why');
    if (!why) return;
    const heading = why.querySelector('h2');
    const lead = why.querySelector('.it-jewellery-why__lead');
    if (heading) heading.textContent = 'Why buy from Imperial Time';
    if (lead) lead.textContent = 'Selected and professionally inspected in Kensington, with clear product information, secure fulfilment and specialist support before and after purchase.';
    const content = [
      ['Inspected before dispatch', 'Materials, construction, finish and overall presentation are checked before your order leaves us.'],
      ['Clear product information', 'Key specifications, imagery and available options are presented to help you make an informed choice.'],
      ['Secure fulfilment', 'Orders are carefully packed and sent using an appropriately insured, tracked service.'],
      ['Specialist support', 'Ask our Kensington team about sizing, product details, additional imagery or a showroom viewing.']
    ];
    [...why.querySelectorAll('.it-jewellery-why__grid article')].forEach((card, index) => {
      const item = content[index];
      if (!item) return;
      const h3 = card.querySelector('h3');
      const p = card.querySelector('p');
      if (h3) h3.textContent = item[0];
      if (p) p.textContent = item[1];
    });
    const faqHead = root.querySelector('.it-jewellery-faq__head h2');
    const faqIntro = root.querySelector('.it-jewellery-faq__head > p:last-child');
    if (faqHead) faqHead.textContent = 'Service, delivery & aftercare';
    if (faqIntro) faqIntro.textContent = 'The practical details that matter before and after you order.';
  }
  function polishConfidenceSuite(family) {
    const suite = document.querySelector('[data-it-jewellery-confidence-suite]');
    if (!suite) return;
    const story = suite.querySelector('.it-jewellery-confidence-story > p');
    if (story) story.textContent = 'Every jewellery piece offered by Imperial Time is professionally inspected before sale. We review materials, construction, condition and presentation, and check the product details shown on the listing before dispatch.';
    const points = [...suite.querySelectorAll('.it-jewellery-confidence-points span')];
    if (points[1]) points[1].textContent = 'Materials & construction reviewed';
    const consultation = suite.querySelector('.it-jewellery-consultation-copy > p:last-child');
    if (consultation) consultation.textContent = consultationCopy(family);
  }
  function consultationCopy(family) {
    switch (family) {
      case 'chain': return 'Before you order, our Kensington team can help you compare length, gauge, materials and the available specification for this chain.';
      case 'ring': return 'Before you order, our Kensington team can help you review sizing, materials, stone details and the available specification for this ring.';
      case 'earring': return 'Before you order, our Kensington team can help you review materials, stone details, dimensions and the available specification for these earrings.';
      case 'bracelet': return 'Before you order, our Kensington team can help you review sizing or length, materials, dimensions and the available specification for this bracelet.';
      case 'pendant': return 'Before you order, our Kensington team can help you review materials, dimensions, stone details and the available specification for this pendant.';
      default: return 'Before you order, our Kensington team can help you review the materials, dimensions, condition, sizing and purchase options shown on this listing.';
    }
  }
  function toneFor(value) {
    const v = String(value || '').toLowerCase();
    if (/rose/.test(v)) return '#c99b8c';
    if (/yellow|gold/.test(v)) return '#d5b55f';
    if (/white|silver|platinum/.test(v)) return '#d8d9d6';
    if (/black|onyx/.test(v)) return '#222';
    if (/blue|sapphire/.test(v)) return '#244e8d';
    if (/green|malachite|emerald/.test(v)) return '#2e6a4b';
    if (/red|ruby/.test(v)) return '#9a2f39';
    if (/pink/.test(v)) return '#d7a4ad';
    return '#d8d5cf';
  }
  function cssEscape(value) {
    return window.CSS?.escape ? CSS.escape(String(value)) : String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));
  }
})();
;
(() => {
  function toneFor(value) {
    const v = String(value || '').toLowerCase();
    if (/rose/.test(v)) return '#c99b8c';
    if (/white|silver|platinum/.test(v)) return '#d8d9d6';
    if (/yellow|gold/.test(v)) return '#d5b55f';
    return '#d8d5cf';
  }
  function applyToneCorrection() {
    document.querySelectorAll('.it-jewellery-pdp .it-final-metal-options input[type="radio"]').forEach(input => {
      const fieldset = input.closest('fieldset');
      const label = fieldset?.querySelector(`label[for="${window.CSS?.escape ? CSS.escape(input.id) : input.id}"]`);
      const tone = label?.querySelector('.it-metal-tone');
      const copy = label?.querySelector('.it-final-metal-copy');
      if (tone) tone.style.setProperty('--it-metal-tone', toneFor(copy?.textContent || input.value));
    });
  }
  function schedule() { setTimeout(applyToneCorrection, 160); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  document.addEventListener('change', event => {
    if (event.target?.closest?.('.it-jewellery-pdp')) schedule();
  }, true);
  document.addEventListener('shopify:section:load', schedule);
})();
;
(() => {
  function money(pence) {
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        maximumFractionDigits: 0
      }).format(pence / 100);
    } catch (_) {
      return '£' + Math.round(pence / 100);
    }
  }
  function syncSavings(root) {
    const holder = root?.querySelector('[data-it-savings]');
    const dataNode = root?.querySelector('[data-it-variant-data]');
    if (!holder || !dataNode) return;
    let variants;
    try { variants = JSON.parse(dataNode.textContent || '[]'); } catch (_) { return; }
    const idInput = root.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
    const selectedId = String(idInput?.value || '');
    const variant = variants.find(v => String(v.id) === selectedId) || variants[0];
    if (!variant) return;
    const saving = Math.max(0, Number(variant.compareAtPrice || 0) - Number(variant.price || 0));
    holder.hidden = saving <= 0;
    holder.textContent = saving > 0 ? 'Save ' + money(saving) : '';
  }
  function hideIrrelevantMetalRates(root) {
    const metal = String(root?.dataset.productMetal || '').toLowerCase();
    if (metal.includes('gold') || metal.includes('platinum')) return;
    for (const heading of document.querySelectorAll('h1,h2,h3')) {
      if (!/precious metal spot rates/i.test(heading.textContent || '')) continue;
      const section = heading.closest('section') || heading.closest('.shopify-section') || heading.parentElement;
      if (section) section.hidden = true;
      break;
    }
  }
  function init() {
    const root = document.querySelector('product-info.it-jewellery-pdp, .it-jewellery-pdp');
    if (!root) return;
    syncSavings(root);
    hideIrrelevantMetalRates(root);
    root.addEventListener('change', () => requestAnimationFrame(() => syncSavings(root)), true);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
;
(() => {
  document.querySelectorAll('[data-it-cro-stage]').forEach(stage => {
    const productId = stage.dataset.productId;
    const root = document.querySelector(`product-info.it-jewellery-pdp[data-product-id="${productId}"]`) || document.querySelector('product-info.it-jewellery-pdp');
    if (!root || stage.dataset.ready) return;
    stage.dataset.ready = 'true';
    const relatedHeading = [...document.querySelectorAll('.related-products h1, .related-products h2, .related-products .title, section[id*=related] h1, section[id*=related] h2')].find(el => /you may also like/i.test(el.textContent || ''));
    if (relatedHeading) relatedHeading.textContent = 'Complete the look';
    const rating = stage.querySelector('[data-it-cro-rating]');
    const payment = root.querySelector('.it-jewellery-payment-note');
    if (rating && payment) payment.after(rating);
    const stagedDetails = stage.querySelector('[data-it-cro-details]');
    const details = root.querySelector('.it-jewellery-details');
    if (details && stagedDetails) {
      [...stagedDetails.children].forEach(node => details.prepend(node));
      const oldDescription = [...details.querySelectorAll('details')].find(d => /description/i.test(d.querySelector('summary')?.textContent || '') && !d.classList.contains('it-cro-specs'));
      if (oldDescription) {
        const descriptionBody = oldDescription.querySelector('.it-detail-content');
        const descriptionText = descriptionBody?.textContent?.replace(/\s+/g, ' ').trim() || '';
        if (!descriptionText) {
          oldDescription.remove();
        } else {
          oldDescription.removeAttribute('open');
          oldDescription.dataset.itFullDescription = 'true';
          const label = oldDescription.querySelector('summary span:first-child');
          if (label) label.textContent = 'Full product description';
        }
      }
    }
    const overrideOpen = stage.querySelector('[data-it-cro-override-open]');
    const overrideDialog = stage.querySelector('[data-it-cro-override-dialog]');
    if (overrideOpen) {
      root.querySelector('.it-jewellery-assistance')?.after(overrideOpen);
      overrideOpen.addEventListener('click', () => overrideDialog?.showModal?.());
    }
    if (overrideDialog) {
      document.body.append(overrideDialog);
      overrideDialog.querySelector('[data-it-cro-override-close]')?.addEventListener('click', () => overrideDialog.close());
      overrideDialog.addEventListener('click', e => { if (e.target === overrideDialog) overrideDialog.close(); });
    }
    enhanceOptions(root);
    root.addEventListener('change', () => setTimeout(() => enhanceOptions(root), 50), true);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, e => { if (e?.data?.sectionId === root.dataset.section) setTimeout(() => enhanceOptions(root), 0); });
    }
    installConfidenceShowroom(root);
    stage.remove();
  });
  function enhanceOptions(root) {
    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-it-variant-data]')?.textContent || '[]'); } catch (_) {}
    const title = (root.querySelector('h1')?.textContent || '').toLowerCase();
    const sku = (root.querySelector('[id^="Sku-"]')?.textContent || '')
      .replace(/^\s*SKU\s*/i, '')
      .trim();
    root.querySelectorAll('[data-it-variant-zone] variant-selects fieldset').forEach((fieldset, index) => {
      const legend = fieldset.querySelector('legend'); if (!legend) return;
      const raw = (legend.textContent.split(':')[0] || '').trim();
      const radios = [...fieldset.querySelectorAll('input[type=radio]')];
      const values = radios.map(i => i.value.trim()).filter(Boolean);
      const n = raw.toLowerCase().trim();
      if (n === 'default' && values.length === 1 && values[0].toLowerCase() === 'default') {
        fieldset.hidden = true;
        fieldset.classList.add('it-synthetic-default-option');
        fieldset.setAttribute('aria-hidden', 'true');
        return;
      }
      if (n === 'weight' && values.length === 1 && sku && values[0].toLowerCase() === sku.toLowerCase()) {
        fieldset.hidden = true;
        fieldset.setAttribute('aria-hidden', 'true');
        return;
      }
      let display = customerName(raw, values, title);
      if (n === 'weight' && values.length === 1 && /^[A-Z0-9][A-Z0-9._/-]{2,}$/i.test(values[0]) && !looksLikeWeight(values[0])) {
        display = 'Reference';
      }
      if (legend.childNodes[0]) legend.childNodes[0].textContent = `${display}: `;
      if (/size/i.test(display)) fieldset.classList.add('it-size-options');
      if (/metal|material/i.test(n)) {
        fieldset.classList.add('it-metal-options');
        legend.textContent = /color|colour/i.test(display) ? 'Metal colour' : 'Metal';
        radios.forEach(input => {
          const label = fieldset.querySelector(`label[for="${cssEscape(input.id)}"]`);
          if (!label || label.querySelector('.it-metal-tone')) return;
          const tone = document.createElement('span');
          tone.className = 'it-metal-tone';
          tone.setAttribute('aria-hidden', 'true');
          tone.style.setProperty('--it-metal-tone', toneFor(input.value));
          label.prepend(tone);
        });
        return;
      }
      if (!/colour|color|stone|gem|material/i.test(display) || !radios.length || radios.length > 12) return;
      const hasImages = radios.some(i => variants.some(v => v.options?.[index] === i.value && v.image));
      if (hasImages) {
        fieldset.classList.add('it-image-options');
        radios.forEach(input => {
          const label = fieldset.querySelector(`label[for="${cssEscape(input.id)}"]`);
          const variant = variants.find(v => v.options?.[index] === input.value && v.image);
          if (!label || !variant || label.querySelector('.it-option-thumb')) return;
          label.querySelectorAll('.label-unavailable,.visually-hidden').forEach(n => n.remove());
          label.textContent = '';
          const image = document.createElement('img'); image.className = 'it-option-thumb'; image.src = variant.image; image.alt = ''; image.loading = 'lazy';
          const copy = document.createElement('span'); copy.className = 'it-option-copy'; copy.textContent = input.value;
          label.append(image, copy);
        });
      } else if (/colour|color/i.test(display)) {
        fieldset.classList.add('it-tone-options');
        radios.forEach(input => {
          const label = fieldset.querySelector(`label[for="${cssEscape(input.id)}"]`); if (!label || label.querySelector('.it-option-tone')) return;
          const tone = document.createElement('span'); tone.className = 'it-option-tone'; tone.style.setProperty('--it-tone', toneFor(input.value)); label.prepend(tone);
        });
      }
    });
  }
  function installConfidenceShowroom(root) {
    if (document.querySelector('[data-it-jewellery-confidence-suite]')) return;
    root.querySelector('.it-kensington-editorial')?.remove();
    const productTitle = (root.querySelector('h1')?.textContent || 'this jewellery piece').trim();
    const whatsappText = `Hello Imperial Time, I would like help reviewing this jewellery piece: ${productTitle} — ${location.href}`;
    const whatsappUrl = `https://wa.me/447538174795?text=${encodeURIComponent(whatsappText)}`;
    const mapsSearchUrl = 'https://www.google.com/maps/search/?api=1&query=79%20Kensington%20Church%20Street%2C%20London%20W8%204BG';
    const mapsDirectionsUrl = 'https://www.google.com/maps/dir/?api=1&destination=79%20Kensington%20Church%20Street%2C%20London%20W8%204BG';
    const suite = document.createElement('section');
    suite.className = 'it-jewellery-confidence-suite it-jewellery-confidence-suite--lean';
    suite.dataset.itJewelleryConfidenceSuite = 'true';
    suite.setAttribute('aria-label', 'Kensington jewellery consultation and showroom support');
    suite.innerHTML = `
      <div class="page-width it-jewellery-consultation-wrap">
        <div class="it-jewellery-consultation">
          <div class="it-jewellery-consultation-header">
            <div class="it-jewellery-consultation-copy"><p class="it-jewellery-suite-kicker">Kensington jewellery consultation</p><h2>Would you like a specialist to review this piece?</h2><p>Before you order, our Kensington team can help you review materials, dimensions, condition, sizing and purchase options shown on this listing.</p></div>
            <div class="it-jewellery-consultation-actions"><a class="it-jewellery-suite-btn it-jewellery-suite-btn--wa" href="${whatsappUrl}" target="_blank" rel="noopener noreferrer" data-jewellery-action="whatsapp">WhatsApp a Jewellery Specialist</a><a class="it-jewellery-suite-btn" href="https://book.imperialtime.co.uk/185231000000030056/#/185231000000030056" target="_blank" rel="noopener noreferrer" data-jewellery-action="appointment">Book a Kensington Appointment</a></div>
          </div>
          <div class="it-jewellery-showroom-grid">
            <div class="it-jewellery-showroom-info"><p class="it-jewellery-suite-kicker">Visit Imperial Time</p><h3>Our Kensington Showroom</h3><address>79 Kensington Church Street<br>London W8 4BG</address><p>Monday–Friday: 10:00–18:00<br>Saturday: Appointment only<br>Sunday: Closed</p><div class="it-jewellery-showroom-links"><a href="${mapsDirectionsUrl}" target="_blank" rel="noopener noreferrer">Get directions in Google Maps ↗</a><a href="${mapsSearchUrl}" target="_blank" rel="noopener noreferrer">Open location ↗</a></div></div>
            <a class="it-jewellery-showroom-image" href="${mapsSearchUrl}" target="_blank" rel="noopener noreferrer" aria-label="View Imperial Time Kensington showroom in Google Maps"><img src="https://cdn.shopify.com/s/files/1/0952/5562/6071/files/Kensington-Showroom.jpg?v=1776083319" alt="Interior of Imperial Time Kensington showroom at 79 Kensington Church Street, London" loading="lazy" width="1248" height="832"><span>Kensington · View on Google Maps ↗</span></a>
            <div class="it-jewellery-map-card"><iframe title="Google map showing Imperial Time at 79 Kensington Church Street, London W8 4BG" src="https://maps.google.com/maps?q=79%20Kensington%20Church%20Street%2C%20London%20W8%204BG&z=15&output=embed" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe><a href="${mapsSearchUrl}" target="_blank" rel="noopener noreferrer">Open in Google Maps ↗</a></div>
          </div>
        </div>
      </div>
    `;
    const related = document.querySelector('.related-products')?.closest('.shopify-section') || document.querySelector('section[id*="related"]')?.closest('.shopify-section') || document.querySelector('.related-products');
    const reviews = document.querySelector('.it-client-reviews');
    if (related?.parentNode) related.parentNode.insertBefore(suite, related);
    else if (reviews?.parentNode) reviews.after(suite);
    else root.after(suite);
  }
  function customerName(raw, values, title) {
    const n = raw.toLowerCase().trim();
    if (n === 'color') return 'Colour';
    if (/ring\s*size/.test(n) || (n === 'size' && /ring/.test(title))) return 'Ring size';
    if (n === 'weight') {
      const joined = values.join(' ').toLowerCase();
      const weight = values.length && values.every(looksLikeWeight);
      const jewellery = /onyx|malachite|agate|pearl|diamond|ruby|sapphire|emerald|topaz|amethyst|opal|turquoise|garnet|quartz|zircon|moissanite|silver|gold|rose|white|yellow|black|blue|green|red|pink|mother of pearl|stone|colour|color/.test(joined);
      if (!weight && jewellery) return 'Stone / colour';
    }
    if (/stone|gem/.test(n) && /colour|color|type/.test(n)) return 'Stone / colour';
    return raw;
  }
  function looksLikeWeight(value) {
    return /^\s*\d+(?:\.\d+)?\s*(?:g|gram|grams|kg|ct|carat|carats|oz)\s*$/i.test(String(value || ''));
  }
  function toneFor(value) { const v=value.toLowerCase(); if(/rose/.test(v))return'#c99b8c';if(/yellow|gold/.test(v))return'#d5b55f';if(/white|silver|platinum/.test(v))return'#d8d9d6';if(/black|onyx/.test(v))return'#222';if(/blue|sapphire/.test(v))return'#244e8d';if(/green|malachite|emerald/.test(v))return'#2e6a4b';if(/red|ruby/.test(v))return'#9a2f39';if(/pink/.test(v))return'#d7a4ad';return'#d8d5cf'; }
  function cssEscape(v) { return window.CSS?.escape ? CSS.escape(String(v)) : String(v).replace(/[^a-zA-Z0-9_-]/g,'\\$&'); }
})();